import { Alert, Box } from '@mui/material'

export function ReportError() {
  return (
    <Box sx={{ m: 3 }}>
      <Alert severity="error">
        Oops! There was an error getting the report. Please reload the page or
        try again later.
      </Alert>
    </Box>
  )
}
